<template>
  <div class="login d-flex justify-center">
    <div class="login-area d-flex justify-center">
      <div class="language-switcher">
        <Button
          block
          dark
          tabindex="1"
          height="30"
          :class="{ 'active-language': currentLang === 'en' }"
          @click.native="updateLanguage('en')">
          English
        </Button>
        <Button
          block
          dark
          tabindex="2"
          height="30"
          :class="{ 'active-language': currentLang === 'es' }"
          @click.native="updateLanguage('es')">
          Spanish
        </Button>
      </div>

      <div class="login-area__form-wrapper d-flex flex-column">
        <div class="logo flex-grow-1 d-flex align-center">
          <Img :src="getImgWithExt(['images', 'logo_drawer', 'svg'])" width="172" />
        </div>
        <div class="login-area__form flex-grow-1">
          <login-form
            v-if="$route.name == 'SignIn'"
            @link-sent-state="updateLinkSent"
          />
          <registration-form v-if="$route.name == 'SignUp'" />
          <comfirm-account v-if="$route.name == 'ConfirmAccount'" />
          <redirect-auto-auth v-if="$route.name == 'RedirectAutoAuth'"/>
        </div>
      </div>
    </div>

    <div v-if="!showBgImage" class="slider-area d-none d-lg-block">
      <div class="slider-area__carusel d-flex justify-center align-center">
        <carousel :items="items" />
      </div>
    </div>
    <div v-if="showBgImage" class="slider-area d-none d-lg-block">
      <img class="bg-image" src="@/assets/images/registered-bg.png" :alt="String($t('alt.registered_bg'))">
    </div>
  </div>
</template>

<script>
import Image from '@/mixins/Image'
import loginForm from '@/components/layouts/forms/login'
import registrationForm from '@/components/layouts/forms/registration'
import comfirmAccount from '@/views/confirm-account'
import carousel from '@/components/layouts/carusel'
import Img from '@/components/elements/Img'
import RedirectAutoAuth from '@/views/redirect-auto-auth.vue'
import Button from '@/components/elements/Button'
export default {
  name: 'login',
  mixins: [Image],
  components: { RedirectAutoAuth, loginForm, registrationForm, comfirmAccount, carousel, Img, Button },
  data: () => ({
    currentLang: null,
    showBgImage: false
  }),
  computed: {
    items () {
      return [
        {
          src: this.getImgWithExt(['images', 'slider', 'slide1', 'jpeg']),
          content: this.$t('slider.slide1')
        },
        {
          src: this.getImgWithExt(['images', 'slider', 'slide2', 'jpeg']),
          content: this.$t('slider.slide2')
        },
        {
          src: this.getImgWithExt(['images', 'slider', 'slide3', 'jpeg']),
          content: this.$t('slider.slide3')
        }
      ]
    }
  },
  created () {
    this.currentLang = this.$i18n?.locale || 'en'
  },
  methods: {
    updateLanguage (lang) {
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang
        this.currentLang = lang
        localStorage.setItem('locale', this.$i18n.locale)
      }
    },
    updateLinkSent(val) {
      this.showBgImage = val
    }
  },
}
</script>

<style lang="scss" scoped>
.login {
  .login-area,
  .slider-area {
    width: 50%;
    height: 100vh;
  }

  .login-area {
    position: relative;
    background-color: #FFFFFF;

    &__form-wrapper {
      width: 424px;
    }
    &__form {
      width: 100%;
    }

    .language-switcher {
      position: absolute;
      top: 23px;
      right: 23px;
      display: flex;
      column-gap: 2px;
      border-radius: 8px;
      background-color: #F7FAFC;
      padding: 2px;
      margin-left: auto;

      .button {
        ::v-deep .v-btn {
          width: 88px;
          color: #425466 !important;
          font-weight: 600 !important;
          font-size: 12px;
          line-height: 1;
          background-color: #F7FAFC !important;
          border-radius: 8px;
          padding: 9px 8px;
        }
      }
      .button.active-language {
        ::v-deep .v-btn {
          color: white !important;
          background-color: #008C89 !important;
        }
      }
    }

    //@media (max-width: 960px) {
    //  width: 100%;
    //  padding: 0 30px;
    //}
  }

  .slider-area {
    position: relative;
    background-color: $dark-green;
    overflow: hidden;
    &__carusel {
      height: 100vh;
    }
  }
}

.bg-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 960px) {
  .login-area {
    width: 100% !important;
    padding: 0 30px;
  }
}

@media screen and (max-width: 500px) {
  .login {
    .login-area {
      flex-direction: column;
      justify-content: flex-start !important;
      padding: 0 15px;

      .language-switcher {
        position: relative;
        right: 0;
      }

      &__form {
        margin-top: 70px;
      }

      &__form-wrapper {
        width: 100%;
        margin-top: 55px;
      }
    }
  }
}
</style>
